/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Style dependencies
 */
import './styles.scss';

const SectionNav = (props) => {
    return (
        <div className={classNames('section-nav', props.className)}>
            <div className='section-nav__panel'>{props.children}</div>
        </div>
    );
};

export default SectionNav;
